/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Image_Pod_Automation_Publish_Title7Inputs */

const en_svc_ai_image_pod_automation_publish_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Publish_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bulk upload to stores`)
};

const ar_svc_ai_image_pod_automation_publish_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Publish_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رفع جماعي للمتاجر`)
};

const bn_svc_ai_image_pod_automation_publish_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Publish_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্টোরে বাল্ক আপলোড`)
};

const de_svc_ai_image_pod_automation_publish_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Publish_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Massen-Upload in Shops`)
};

const es_svc_ai_image_pod_automation_publish_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Publish_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subida masiva a tiendas`)
};

const fr_svc_ai_image_pod_automation_publish_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Publish_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoi en masse vers les boutiques`)
};

const pt_svc_ai_image_pod_automation_publish_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Publish_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subida em massa para lojas`)
};

const zh_svc_ai_image_pod_automation_publish_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Publish_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批量上架店铺`)
};

const tr_svc_ai_image_pod_automation_publish_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Publish_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mağazalara toplu yükleme`)
};

const ru_svc_ai_image_pod_automation_publish_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Publish_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Массовая загрузка в магазины`)
};

const pl_svc_ai_image_pod_automation_publish_title7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Publish_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masowy upload do sklepów`)
};

/**
* | output |
* | --- |
* | "Bulk upload to stores" |
*
* @param {Svc_Ai_Image_Pod_Automation_Publish_Title7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_image_pod_automation_publish_title7 = /** @type {((inputs?: Svc_Ai_Image_Pod_Automation_Publish_Title7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Image_Pod_Automation_Publish_Title7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_image_pod_automation_publish_title7(inputs)
	if (locale === "bn") return bn_svc_ai_image_pod_automation_publish_title7(inputs)
	if (locale === "de") return de_svc_ai_image_pod_automation_publish_title7(inputs)
	if (locale === "es") return es_svc_ai_image_pod_automation_publish_title7(inputs)
	if (locale === "fr") return fr_svc_ai_image_pod_automation_publish_title7(inputs)
	if (locale === "pt") return pt_svc_ai_image_pod_automation_publish_title7(inputs)
	if (locale === "zh") return zh_svc_ai_image_pod_automation_publish_title7(inputs)
	if (locale === "tr") return tr_svc_ai_image_pod_automation_publish_title7(inputs)
	if (locale === "ru") return ru_svc_ai_image_pod_automation_publish_title7(inputs)
	if (locale === "pl") return pl_svc_ai_image_pod_automation_publish_title7(inputs)
	return en_svc_ai_image_pod_automation_publish_title7(inputs)
});
export { svc_ai_image_pod_automation_publish_title7 as "svc_ai-image-pod-automation_PUBLISH_title" }